import React, { useState, useEffect, useReducer, useRef } from "react";
import {
  CONFIG,
  sizeValues,
  fontValues,
  headerValues,
} from "../common/rps/config";
import rpsReducer from "../../reducers/rps";
import ScrollView from "devextreme-react/scroll-view";
import NumberBox from "devextreme-react/number-box";
import Button from "devextreme-react/button";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { alert } from "devextreme/ui/dialog";
import { postUserLog } from "../../actions/common";
import TextBox from "devextreme-react/text-box";
import * as action from "../../actions/rps";

const initialStates = {
  approvers: [],
  peopleData: [],
  reasonCodes: [],
  peopleList: [],
};

const ReasonforAction = ({
  rpsID,
  siteId,
  tierId,
  setisOpen,
  handleSPSSave,
  isDataSaved,
  navigationOn,
}) => {
  const [enableKPI, setEnableKPI] = useState(true);
  const [theRpsId, setTheRpsId] = useState(rpsID);
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  const [kpiUnit, setKPIUnit] = useState([]);
  const [areaToSolve, setAreaToSolve] = useState([]);
  const [active, setActive] = useState(1);
  const [currentGoal, setCurrentGoal] = useState([]);
  const [currentState, setCurrentState] = useState([]);
  const [spsSteps, setSteps] = useState(NEXUS_CONST.SPS_STEPS);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    let siteInfo = `&siteId=` + siteId;
    if (theRpsId) {
      AsyncCallHandler(
        NEXUS_CONST.FETCH_PS_DATA + theRpsId,
        NEXUS_CONST.GET
      ).then((res) => {
        if (res) {
          setAreaToSolve(res.data.areaToSolve);
            setCurrentGoal(res.data.currentGoal);
            setKPIUnit(res.data.kpiunits);
            setCurrentState(res.data.currentState);
          setIsDisabled(res?.data?.status === "Complete");
        }
      });
    }
  }, []);

  const onKPIChange = (e) => {
    setKPIUnit(e.value);
    setEnableKPI(false);
  };

  const onCurrentStateChanged = (e) => {
    setCurrentState(e.value);
  };

  const calculateReason = () => {
    let _currentGoal = currentGoal !== null ? currentGoal : 0;
    let _currentState = currentState !== null ? currentState : 0;
    let _kpiUnit = kpiUnit == null ? "" : kpiUnit;

    let _value =
      [_currentGoal - _currentState] +
      " " +
      _kpiUnit +
      " Gap ON " +
      areaToSolve;
    return _value;
  };
  const saveRA = () => {
    let _ReasonforAction = { ...ReasonforAction };
    if (kpiUnit === null) {
      alert("Please enter KPI units", "Alert");
    } else if (currentGoal === null) {
      alert("Please enter Current goal", "Alert");
    } else if (currentState === null) {
      alert("Please enter Current state", "Alert");
    } else {
      let formData = {
        rpsid: theRpsId === null ? 0 : parseInt(theRpsId),
        tierId: parseInt(tierId),
        KPIUnits: kpiUnit.toString(),
        CurrentGoal: currentGoal.toString(),
        CurrentState: currentState.toString(),
        lastSavedTab: "1",
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_PS_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (res) {
          handleSPSSave();
          isDataSaved(7);
          isDataSaved(9);
          setisOpen("1");
          postUserLog({
            event: "Box 1 - Reason for Action",
            data: {
              action: `PS-${rpsID} Saved`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }
      });
    }
    setisOpen("1");
  };

  return (
    <>
      <div className="title-section ">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 1 - &nbsp;</span>Reason for Action
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveRA}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div className="dx-field">
          <TextBox
            name="kpiUnit*"
            label="KPI Unit*"
            labelMode="floating"
            onValueChanged={onKPIChange}
            value={kpiUnit}
          ></TextBox>
        </div>
        <div className="dx-field">
          <NumberBox
            className="dx-field-value"
            name="currentGoal"
            label="Current Goal *"
            //disabled={enableKPI}
            labelMode="floating"
            value={currentGoal}
            onValueChanged={(e) => setCurrentGoal(e.value)}
            useMaskBehavior={true}
          ></NumberBox>
        </div>
        <div className="dx-field">
          <NumberBox
            className="dx-field-value"
            label="Current State"
            labelMode="floating"
            name="CurrentState"
            value={currentState}
            onValueChanged={onCurrentStateChanged}
            useMaskBehavior={true}
          ></NumberBox>
        </div>
        <h4 className="target-statement">{`Problem Statement : ${calculateReason()}`}</h4>
      </ScrollView>
    </>
  );
};
export default ReasonforAction;
